export var BookingCategory;
(function (BookingCategory) {
    BookingCategory["FLIGHT"] = "FLIGHT";
    BookingCategory["HOTEL"] = "HOTEL";
})(BookingCategory || (BookingCategory = {}));
export var TripCategory;
(function (TripCategory) {
    TripCategory["ONE_WAY"] = "one_way";
    TripCategory["ROUND_TRIP"] = "round_trip";
    TripCategory["MULTI_CITY"] = "multi_city";
})(TripCategory || (TripCategory = {}));
export var SeverityEnum;
(function (SeverityEnum) {
    SeverityEnum["Fatal"] = "Fatal";
    SeverityEnum["Warning"] = "Warning";
})(SeverityEnum || (SeverityEnum = {}));
export var ScalingFactor;
(function (ScalingFactor) {
    ScalingFactor["X1"] = "1x";
    ScalingFactor["X1Point5"] = "1.5x";
    ScalingFactor["X2"] = "2x";
    ScalingFactor["X3"] = "3x";
    ScalingFactor["X4"] = "4x";
})(ScalingFactor || (ScalingFactor = {}));
export var EMAIL_FOR_SIGN_IN = "emailForSignIn";
export var EMAIL_LINK_URL = "emailLinkUrl";
export var Locale;
(function (Locale) {
    Locale["EN_US"] = "en_US";
})(Locale || (Locale = {}));
export var DateTimeZone;
(function (DateTimeZone) {
    DateTimeZone["AMERICA_TORONTO"] = "America/Toronto";
})(DateTimeZone || (DateTimeZone = {}));
export var FlightRatingsEnum;
(function (FlightRatingsEnum) {
    FlightRatingsEnum[FlightRatingsEnum["basic"] = 0] = "basic";
    FlightRatingsEnum[FlightRatingsEnum["standard"] = 1] = "standard";
    FlightRatingsEnum[FlightRatingsEnum["enhanced"] = 2] = "enhanced";
    FlightRatingsEnum[FlightRatingsEnum["premium"] = 3] = "premium";
    FlightRatingsEnum[FlightRatingsEnum["luxury"] = 4] = "luxury";
})(FlightRatingsEnum || (FlightRatingsEnum = {}));
export var FlightSortOption;
(function (FlightSortOption) {
    FlightSortOption["ArrivalTime"] = "arrivalTime";
    FlightSortOption["DepartureTime"] = "departureTime";
    FlightSortOption["Duration"] = "duration";
    FlightSortOption["FareScore"] = "fareScore";
    FlightSortOption["Price"] = "price";
    FlightSortOption["Stops"] = "stops";
})(FlightSortOption || (FlightSortOption = {}));
export var FlightEntryTypeEnum;
(function (FlightEntryTypeEnum) {
    FlightEntryTypeEnum["RECENTLY_SEARCHED_AIR"] = "recently_searched_air";
    FlightEntryTypeEnum["RECENTLY_SEARCH_AUTOCOMPLETE"] = "recently_searched_autocomplete";
    FlightEntryTypeEnum["TRAVEL_SALE_LANDING"] = "travel_sale_landing";
    FlightEntryTypeEnum["TRAVEL_SALE_HOMEPAGE"] = "travel_sale_homepage";
    FlightEntryTypeEnum["CROSS_SELL_STAYS_CONFIRMATION"] = "cross_sell_stays_confirmation";
})(FlightEntryTypeEnum || (FlightEntryTypeEnum = {}));
export function parseFlightEntryType(value) {
    return Object.values(FlightEntryTypeEnum).includes(value)
        ? value
        : null;
}
//# sourceMappingURL=interfaces.js.map